// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".remove-event-family_d73334e0{color:#b32700}.remove-event-family_d73334e0:hover{color:#b32700}", ""]);
// Exports
export var removeEventFamily = "remove-event-family_d73334e0";
export default ___CSS_LOADER_EXPORT___;
